var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthiopianFlag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7df4b",
    d: "M1 11H31V21H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z",
    fill: "#3c883a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z",
    transform: "rotate(180 16 24)",
    fill: "#c92d25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z",
    opacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 6,
    fill: "#1e44aa"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10.909l-.223,.686,.92,2.831h-1.227l-.138,.424h3.933l.584-.424h-2.706l-1.143-3.518Z",
    fill: "#f6dd4c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-53.973 18.182 12.997)",
    fill: "#f6dd4c",
    d: "M16.803 12.891H19.561V13.104H16.803z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.842,14.427h-.722s-2.409,1.75-2.409,1.75l-.379-1.167h-.446s1.215,3.741,1.215,3.741l.584,.424-.836-2.574,2.992-2.174Z",
    fill: "#f6dd4c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6dd4c",
    d: "M20.809 17.674L18.186 16.822 18.252 16.62 20.875 17.472 20.809 17.674z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.992,20.119l-.223-.686-2.409-1.75,.992-.721-.138-.424-3.182,2.312-.223,.686,2.19-1.591,2.992,2.174Z",
    fill: "#f6dd4c"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6dd4c",
    d: "M15.894 18.333H16.107V21.090999999999998H15.894z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.008,20.119l.584-.424,.92-2.831,.992,.721,.361-.262-3.182-2.312h-.722s2.19,1.591,2.19,1.591l-1.143,3.518Z",
    fill: "#f6dd4c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6dd4c",
    d: "M11.191 17.674L11.125 17.472 13.748 16.62 13.814 16.822 11.191 17.674z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.158,14.427l.584,.424h2.977s-.379,1.167-.379,1.167l.361,.262,1.215-3.741-.223-.686-.836,2.574h-3.699Z",
    fill: "#f6dd4c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-36.004 13.819 12.996)",
    fill: "#f6dd4c",
    d: "M13.712 11.618H13.924999999999999V14.376000000000001H13.712z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z",
    fill: "#fff",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiopianFlag);
export default __webpack_public_path__ + "static/media/ethiopian-flag.eaa31316cf0dd95b0d70a031dcc37a3a.svg";
export { ForwardRef as ReactComponent };